import { useEffect, RefObject } from 'react';
import { PopoverTriggerBy } from 'components/PopoverBase/types';

/** Portaled react-multi-date-picker UI (see MultiDatePicker portal={true}) */
const PORTAL_DATE_PICKER_SELECTOR = '.rmdp-wrapper, .rmdp-container';

/** Portaled APopover content (see PopoverBase usePortal) */
const PORTAL_POPOVER_SELECTOR = '[data-apopover-portal]';

const useOnClickOutside = (
  ref: RefObject<HTMLElement>,
  handler: (e: Event) => void,
  shouldCapture: boolean,
  trigger: PopoverTriggerBy
) => {
  useEffect(() => {
    if (trigger === 'hover') {
      return;
    }
    if (ref.current && ref.current.getElementsByTagName('a').length !== 0) {
      // get the onClick event
      const aTags = ref.current.getElementsByTagName('a');
      for (let i = 0; i < aTags.length; i++) {
        const element = aTags[i];
        // element.addEventListener('sync-click', () => {
        //   if (element.onclick !== null) {
        //     element.onclick.bind(element);
        //     // element.onclick.call()
        //   }
        // });
        const syncOnClickWithClose = () => {
          if (element.onclick !== null) {
            element.onclick.bind(element);
            // element.dispatchEvent(new CustomEvent('sync-click'));
            // setTimeout(handler(e), 300);
          }
          // handler(event);
        };
        element.onclick = syncOnClickWithClose;
        // console.warn('the element', element);
      }
    }
    const listener = (event: Event) => {
      const target = event.target as Element;
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(target)) {
        if (target.tagName === 'A' && event.target) {
          // event.target.dispatchEvent(event);
          // handler(event);
          // event.preventDefault();
          // event.stopImmediatePropagation();
          // event.returnValue = false;
          // setTimeout(handler(event), 10);
        }
        return;
      }

      if (
        target.closest?.(PORTAL_DATE_PICKER_SELECTOR) ||
        target.closest?.(PORTAL_POPOVER_SELECTOR)
      ) {
        return;
      }

      handler(event);
    };
    if (shouldCapture) {
      document.addEventListener('mousedown', listener, true);
      document.addEventListener('touchstart', listener, true);
    }

    return () => {
      if (shouldCapture) {
        document.removeEventListener('mousedown', listener);
        document.removeEventListener('touchstart', listener);
      }
    };
  }, [ref, handler, shouldCapture, trigger]); // ... passing it into this hook. // ... but to optimize you can wrap handler in useCallback before ... // ... callback/cleanup to run every render. It's not a big deal ... // ... function on every render that will cause this effect ... // It's worth noting that because passed in handler is a new ... // Add ref and handler to effect dependencies
};

export default useOnClickOutside;
